import React, { Component } from "react";
import ReactDOMServer from "react-dom/server";

import { PieChart, Pie, Cell, Tooltip, BarChart, Bar, YAxis } from 'recharts';

import Grid from "@material-ui/core/Grid";
import SvgIcon from "@material-ui/core/SvgIcon";

import ChartMenu from "./../ChartMenu/ChartMenu";
import DoughnutLegend from "./DoughnutLegend";
import CustomTooltip from "./DoughnutTooltip";
import GenericTooltip from "./../GenericTooltip";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "./../../../../Actions/Dashboard";

import * as Characteristics from '../../../../constants//icons/characteristics/Characteristics';
import { DOUGHNUT_DASHBOARD_CONTAINER } from './../../../../constants/strings/StringsDashboard';

import './DoughnutStyle.css'

class DoughnutComponent extends Component {
  constructor(props) {
    super(props);
    let type = "doughnut";
    // if (props.data.length > 4) type = "bar";
    this.state = {
      type: type,
      colors: props.colors,
    };
  }

  createMarkup(string, color) {
    let cadena = string.toString().replace(/green/g, color);
    cadena = cadena.toString().replace(/#038bc0/g, color);
    cadena = cadena.toString().replace(/#0070a1/g, color);
    cadena = cadena.toString().replace(/#003951/g, color);
    cadena = cadena.toString().replace(/#006290/g, color);
    cadena = cadena.toString().replace(/#00629d/g, color);
    cadena = cadena.toString().replace(/#1a171b/g, color);
    cadena = cadena.toString().replace(/#646265/g, color);
    return { __html: cadena };
  }

  getSvgIcon = (name, color) => {
    let caseType = "";
    try {
      caseType = name.toLowerCase();
    } catch (err) { }
    switch (caseType) {
      case "0 - 13":
        return Characteristics.GE_0_13(color);
      case "14 - 17":
        return Characteristics.GE_14_17(color);
      case "18 - 27":
        return Characteristics.GE_18_27(color);
      case "28 - 59":
        return Characteristics.GE_28_59(color);
      case "más 60":
        return Characteristics.GE_60MAS(color);
      case "60+":
        return Characteristics.GE_60MAS(color);
      /* ***************************** */
      case "madrugada":
        return Characteristics.JORNADA_MADRUGADA(color);
      case "noche":
        return Characteristics.JORNADA_NOCHE(color);
      case "mañana":
        return Characteristics.JORNADA_MAÑANA(color);
      case "tarde":
        return Characteristics.JORNADA_TARDE(color);
      /* ***************************** */
      case "masculino":
        return Characteristics.GENERO_MASCULINO(color);
      case "femenino":
        return Characteristics.GENERO_FEMENINO(color);
      case "lgbtiq":
        return Characteristics.GENERO_LGBTI(color);
      /* ***************************** */
      case "viudo(a)":
        return Characteristics.ESTADO_CIVIL_VIUDO(color);
      case "viudo":
        return Characteristics.ESTADO_CIVIL_VIUDO(color);
      case "soltero(a)":
        return Characteristics.ESTADO_CIVIL_SOLTERO(color);
      case "soltero":
        return Characteristics.ESTADO_CIVIL_SOLTERO(color);
      case "divorciado(a)":
        return Characteristics.ESTADO_CIVIL_SEPARADO(color);
      case "divorciado":
        return Characteristics.ESTADO_CIVIL_SEPARADO(color);
      case "separado":
        return Characteristics.ESTADO_CIVIL_SEPARADO(color);
      case "casado(a)":
        return Characteristics.ESTADO_CIVIL_CASADO(color);
      case "casado":
        return Characteristics.ESTADO_CIVIL_CASADO(color);
      case "unión libre":
        return Characteristics.ESTADO_CIVIL_UNION(color);
      /* ***************************** */
      case "bicicleta":
        return Characteristics.MOVIL_BICICLETA(color);
      case "conductor bus":
        return Characteristics.MOVIL_CON_BUS(color);
      case "conductor moto":
      case "conductor motocicleta":
        return Characteristics.MOVIL_CON_MOTO(color);
      case "conductor taxi":
        return Characteristics.MOVIL_CON_TAXI(color);
      case "conductor vehículo":
        return Characteristics.MOVIL_CON_VEHICULO(color);
      case "conductor aeronave":
        return Characteristics.MOVIL_PAS_AERO(color);
      case "pasajero barco":
        return Characteristics.MOVIL_PAS_BARCO(color);
      case "pasajero bus":
        return Characteristics.MOVIL_PAS_BUS(color);
      case "pasajero metro":
        return Characteristics.MOVIL_PAS_METRO(color);
      case "pasajero moto":
      case "pasajero motocicleta":
        return Characteristics.MOVIL_PAS_MOTO(color);
      case "pasajero taxi":
        return Characteristics.MOVIL_PAS_TAXI(color);
      case "pasajero vehiculo":
      case "pasajero vehículo":
        return Characteristics.MOVIL_PAS_VEHI(color);
      case "a pie":
      case "a pié":
        return Characteristics.MOVIL_A_PIE(color);
      /* ***************************** */
      case "rural":
        return Characteristics.ZONA_RURAL(color);
      case "urbana":
        return Characteristics.ZONA_URBANA(color);
      /* ***************************** */
      case "superior":
        return Characteristics.ESCOLARIDAD_UNIVERSITARIO(color);
      case "tecnológico":
        return Characteristics.ESCOLARIDAD_TECNOLOGO(color);
      case "técnico":
        return Characteristics.ESCOLARIDAD_TECNICO(color);
      case "primaria":
        return Characteristics.ESCOLARIDAD_PRIMARIA(color);
      case "secundaria":
        return Characteristics.ESCOLARIDAD_BACHILLER(color);
      case "analfabeta":
        return Characteristics.ESCOLARIDAD_ANALFABEBTISMO(color);
      /* ***************************** */
      case "ahogamiento":
        return Characteristics.ARMA_AHOGAMIENTO(color);
      case "ahorcamiento":
        return Characteristics.ARMA_AHORCAMIENTO(color);
      case "animales":
        return Characteristics.ARMA_ANIMALES(color);
      case "arma blanca / cortopunzante":
        return Characteristics.ARMA_BLANCA(color);
      case "arma de fuego":
        return Characteristics.ARMA_FUEGO(color);
      case "caida":
        return Characteristics.ARMA_CAIDA(color);
      case "contundentes":
        return Characteristics.ARMA_CONTUNDENTE(color);
      case "drogas":
      case "escopolamina":
        return Characteristics.ARMA_DROGA(color);
      case "artefacto explosivo":
        return Characteristics.ARMA_EXPLOSIVOS(color);
      case "sin empleo de armas":
        return Characteristics.SIN_ARMAS(color);
      case "quemaduras":
        return Characteristics.ARMA_QUEMADURAS(color);
      case "vehiculo":
        return Characteristics.MOVIL_CON_VEHICULO(color);
      /* ***************************** */
      case "si":
        return (
          <text x="0" y="22" font-family="Verdana" font-size="14" fill={color}>
            SI
          </text>
        );
      case "no":
        return (
          <text x="0" y="22" font-family="Verdana" font-size="14" fill={color}>
            NO
          </text>
        );
      /* ***************************** */
      default:
        return Characteristics.CUADRADO(color);
    }
  };

  getSvgString = (name, color) => {
    return ReactDOMServer.renderToString(this.getSvgIcon(name, color));
  };

  getSvgArray = (colors) => {
    let data = this.props.data;
    let vect = [];
    for (let i = 0; i < data.length; i++) {
      vect.push(this.getSvgString(data[i].name, colors[i % colors.length]));
    }
    return vect;
  };

  getStyle = (val) => {
    if (val >= 5) return "two-lines";
    return "";
  };

  onClick = (uno, dos) => {
    try {
      const type = this.props.name.split("_");
      this.props.actions.selectFilter(
        { id: this.props.data[dos].id, value: this.props.data[dos].name },
        type[type.length - 1]
      );
    } catch (e) { }
  };

  onChangeGraph = () => {
    if (this.state.type === "doughnut") {
      this.setState({ type: "bar" });
    } else {
      this.setState({ type: "doughnut" });
    }
  };

  onChangeColor = (color) => {
    console.log("cambio color: ", color);
    if (color === "Verde") {
      this.setState({ colors: Characteristics.colors });
    } else if (color === "Rojo") {
      this.setState({ colors: Characteristics.colors1 });
    } else if (color === "Verde-Azul") {
      this.setState({ colors: Characteristics.colors2 });
    } else if (color === "Gris") {
      this.setState({ colors: Characteristics.colors3 });
    } else if (color === "Azul") {
      this.setState({ colors: Characteristics.colors4 });
    } else if (color === "Policromático") {
      this.setState({ colors: this.props.title === 'Género' ? Characteristics.colorsG : Characteristics.colors5 });
    }
  };

  setChangeGraph = () => {
    if (this.props.data.length > 4) return false;
    return true;
  };

  getPercentege = (val) => {
    const { data } = this.props;
    let sum = data.reduce((a, b) => ({ value: a.value + b.value })).value;
    return parseInt((val / sum) * 100) + "%";
  };

  domain = () => {
    if (this.props.data.length === 0) return [0, 0];
    let resp = this.props.data.reduce((acum, data) => {
      if (acum.value < data.value) return data;
      return acum;
    });
    return [0, parseInt(resp.value * 1.2) + 1];
  };

  getCorte = () => {
    try {
      return (
        <Grid container>
          <Grid
            item
            xs={12}
            className="text-center client-label-second-color font-12"
          >
            Actualizado a: {this.props.date.split("T")[0]}
          </Grid>
        </Grid>
      );
    } catch (error) { }
    return <></>
  };

  getColor = (index, icon) => {
    if(!icon) return this.state.colors[index % this.state.colors.length]
    switch (icon.toUpperCase()) {
      case 'MASCULINO': return this.state.colors[0];
      case 'FEMENINO': return this.state.colors[1];
      default: return this.state.colors[index % this.state.colors.length]
    }
  }

  render() {
    const { data } = this.props;
    const width = this.props.width ? this.props.width : 300
    const height = this.props.height ? this.props.height : 250
    const total = () => {
      var temp = 0;
      for (let i = 0; i < data.length; i++) {
        temp = temp + data[i].value;
      }
      return temp;
    };
    return (
      <Grid
        style={{ flexWrap: "inherit", margin: "auto" }}
        id={this.props.name}
        item
        xs={12}
      >
        <ChartMenu
          graph={this.props.name}
          file={this.props.title}
          openDialog={this.props.openDialog}
          title={this.props.title}
          watch={this.props.watchMenu}
          seeMore={this.props.seeMore}
          onChangeGraph={this.onChangeGraph}
          // changeGraph={this.setChangeGraph()}
          changeGraph={true}
          changeColor={true}
          onChangeColor={this.onChangeColor}
        />
        <Grid>
          <Grid container>
            <Grid item xs={1}></Grid>
            <Grid item xs={10} style={{ textAlign: "center" }}>
              {this.props.data.map((entry, index) => (
                <div
                  className="legend-box"
                  key={"item-pie-" + this.props.name + index}
                >
                  <div>
                    <svg
                      fill={this.getColor(index, entry.name)}
                      height="30"
                      width="30"
                    >
                      {this.getSvgIcon(
                        entry.name,
                        this.getColor(index, entry.name)
                      )}
                    </svg>
                  </div>
                  <p>{entry.name}</p>
                </div>
              ))}
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
          {this.state.type === "doughnut" ? (
            <Grid container className="text-center">
              <Grid
                item
                xs={7}
                sm={9}
                className="graphic-margin-top client-label "
                style={{ textAlign: "center" }}
              >
                <PieChart width={width} height={height} style={{ margin: "auto" }}>
                  <Pie
                    data={this.props.data}
                    cx={"50%"}
                    cy={"50%"}
                    innerRadius={"30%"}
                    outerRadius={"95%"}
                    // label={renderCustomizedLabel}
                    isAnimationActive={false}
                    onClick={this.onClick}
                    className="on-mouse-hover"
                  >
                    {this.props.data.map((entry, index) => (
                      <Cell
                        fill={
                          this.getColor(index, entry.name)
                        }
                        key={"cell-pie-" + this.props.name + index}
                      />
                    ))}
                  </Pie>
                  <Tooltip
                    content={
                      <CustomTooltip
                        data={this.props.data}
                        colors={this.state.colors}
                        total={total()}
                        svgs={this.getSvgArray(this.state.colors)}
                      />
                    }
                  />
                </PieChart>
              </Grid>
              <Grid item xs={5} sm={3} className="graphic-margin-top">
                <label style={{ fontWeight: "bold" }}>
                  {DOUGHNUT_DASHBOARD_CONTAINER.TOTAL + ": " + total()}
                </label>
                <ul
                  className={
                    "client-list " + this.getStyle(this.props.data.length)
                  }
                  style={{ maxHeight: "220px" }}
                >
                  {this.props.data.map((value, i) => (
                    <li key={"list-pie-" + this.props.name + i}>
                      <SvgIcon
                        style={{
                          marginTop: "5px",
                          marginRight: "0",
                          color: this.state.colors[
                            i % this.state.colors.length
                          ],
                        }}
                      >
                        <svg
                          dangerouslySetInnerHTML={this.createMarkup(
                            this.getSvgString(
                              value.name,
                              this.state.colors[i % this.state.colors.length]
                            ),
                            this.state.colors[i % this.state.colors.length]
                          )}
                        />
                      </SvgIcon>
                      <DoughnutLegend
                        markup={this.getSvgString(
                          value.name,
                          this.state.colors[i % this.state.colors.length]
                        )}
                        color={this.state.colors[i % this.state.colors.length]}
                        label={
                          value.value + " - " + this.getPercentege(value.value)
                        }
                        name={value.name}
                      />
                    </li>
                  ))}
                </ul>
              </Grid>
            </Grid>
          ) : (
            <Grid container className="text-center">
              <Grid item xs={9} className="graphic-margin-top text-center">
                <BarChart
                  width={width + 90}
                  height={250}
                  data={data}
                  isAnimationActive={false}
                  style={{ margin: "auto" }}
                  onClick={this.onClick}
                >
                  {/* <XAxis dataKey="name" fontSize={10} tick={<CustomTick colors={this.state.colors} getSvgIcon={this.getSvgIcon} />} interval={0} /> */}
                  <YAxis
                    fontSize={12}
                    allowDecimals={false}
                    domain={this.domain()}
                  />
                  <Tooltip
                    content={
                      <GenericTooltip
                        data={this.props.data}
                        colors={this.state.colors}
                      />
                    }
                  />
                  <Bar
                    dataKey={"value"}
                    fill="#006290"
                    onClick={this.onClick}
                    className="on-mouse-hover"
                    label={{ position: "top", fontSize: 14 }}
                  >
                    {this.props.data.map((entry, index) => (
                      <Cell
                        key={"cell-bar-" + this.props.name + index}
                        fill={
                          this.getColor(index, entry.name)
                        }
                      />
                    ))}
                  </Bar>
                </BarChart>
              </Grid>
              <Grid item xs={3} className="text-center">
                <label style={{ fontWeight: "bold" }}>
                  {DOUGHNUT_DASHBOARD_CONTAINER.TOTAL + ": " + total()}
                </label>
              </Grid>
            </Grid>
          )}
        </Grid>
        {this.props.date !== undefined && this.getCorte()}
      </Grid>
    );
  }
}

function mapDispathToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

export default connect(null, mapDispathToProps)(DoughnutComponent);
